import type { SpotLieRound } from "./spotlie.ts";

export const NOTANY_SPOTLIE_DECK_EL: readonly SpotLieRound[] = [
  {
    intro: "Μια προοπτική συνοψίζει όσα άκουσαν για το notanyai:",
    claims: [
      {
        text: "Το notanyai προσαρμόζει τη δυσκολία ερώτησης σε κάθε μαθητή ξεχωριστά.",
        isLie: false,
        conceptId: "adaptive_core",
      },
      {
        text: "Το notanyai μπορεί να διδάξει οποιοδήποτε μάθημα — ο γραμματισμός AI είναι μόνο το πρώτο.",
        isLie: false,
        conceptId: "your_content",
      },
      {
        text: "Το notanyai απαιτεί από εσάς να στείλετε το περιεχόμενό σας σε ένα εξωτερικό SaaS για να λειτουργήσει.",
        isLie: true,
        conceptId: "self_hosted",
      },
    ],
  },
  {
    intro: "Σημειώσεις από έλεγχο ασφαλείας:",
    claims: [
      {
        text: "Μπορεί να τρέξει εξ ολοκλήρου μέσα στο δικό σας σύννεφο ή VPC.",
        isLie: false,
        conceptId: "self_hosted",
      },
      {
        text: "Οι διαγραμμένοι λογαριασμοί διατηρούν για πάντα πλήρως αναγνωρίσιμο ιστορικό.",
        isLie: true,
        conceptId: "privacy_first",
      },
      {
        text: "Η ασφάλεια σε επίπεδο σειράς απομονώνει τα δεδομένα κάθε μαθητή.",
        isLie: false,
        conceptId: "privacy_first",
      },
    ],
  },
  {
    intro: "Σχετικά με την απόδειξη ικανότητας:",
    claims: [
      {
        text: "Η μαεστρία παρακολουθείται ανά έννοια και ανά άτομο.",
        isLie: false,
        conceptId: "measured_proof",
      },
      {
        text: 'Η μόνη διαθέσιμη μέτρηση είναι "αριθμός βίντεο που παρακολουθήθηκαν".',
        isLie: true,
        conceptId: "measured_proof",
      },
      {
        text: "Μπορείτε να προσκομίσετε ελεγχόμενα στοιχεία για το ποιος έμαθε τι.",
        isLie: false,
        conceptId: "measured_proof",
      },
    ],
  },
  {
    intro: "Πώς επιλέγει ο κινητήρας την επόμενη ερώτηση:",
    claims: [
      {
        text: "Συνδυάζει Elo, κεντρικότητα γραφήματος και μοντέλο μαεστρίας.",
        isLie: false,
        conceptId: "adaptive_core",
      },
      {
        text: "Η λογική επιλογής είναι ένα μαύρο κουτί που δεν μπορείτε να επιθεωρήσετε.",
        isLie: true,
        conceptId: "adaptive_core",
      },
      {
        text: "Μια σωστή απάντηση μπορεί να ενημερώσει σχετικές έννοιες στο γράφημα.",
        isLie: false,
        conceptId: "adaptive_core",
      },
    ],
  },
  {
    intro: "Σχετικά με το κόστος λειτουργίας και το κλείδωμα:",
    claims: [
      {
        text: "Η παραγωγή μπορεί να τρέξει σε ένα μόνο μικρό ARM VM.",
        isLie: false,
        conceptId: "self_hosted",
      },
      {
        text: "Υπάρχει μια ιδιόκτητη μορφή περιεχομένου που δεν μπορείτε ποτέ να εξαγάγετε.",
        isLie: true,
        conceptId: "your_content",
      },
      {
        text: "Το μπροστινό μέρος είναι ένα στατικό πακέτο που μπορείτε να φιλοξενήσετε οπουδήποτε.",
        isLie: false,
        conceptId: "self_hosted",
      },
    ],
  },
  {
    intro: "Ο βρόχος δέσμευσης, εξήγησε:",
    claims: [
      {
        text: "Οι ραβδώσεις, τα μίνι παιχνίδια και οι αποστολές κάνουν τους μαθητές να επιστρέφουν.",
        isLie: false,
        conceptId: "adaptive_core",
      },
      {
        text: "Οι μαθητές πρέπει να συμμετέχουν σε υποχρεωτικές εβδομαδιαίες συναντήσεις για να προχωρήσουν.",
        isLie: true,
        conceptId: "adaptive_core",
      },
      {
        text: "Οι εκπαιδευόμενοι μπορούν να επιλέξουν έναν ασθενή, ένα τρυπάνι ή ένα ισορροπημένο στυλ GameMaster.",
        isLie: false,
        conceptId: "adaptive_core",
      },
    ],
  },
] as const;
